<script>
// import supabase from '@/etc/supabase'
const { VUE_APP_S3 } = process.env

function normalizeBase(base) {
  return `${base || ''}`.trim().replace(/\/+$/, '')
}

function toAppS3Url(rawValue) {
  const raw = `${rawValue || ''}`.trim()
  if (!raw) return ''
  const base = normalizeBase(VUE_APP_S3)
  if (/^https?:\/\//i.test(raw)) {
    const m = raw.match(/\/s3\/(.+)$/i)
    if (m && m[1] && base) return `${base}/${m[1]}`
    return raw
  }
  if (raw.startsWith('/')) return raw
  if (!base) return raw
  return `${base}/${raw.replace(/^\/+/, '')}`
}

export default {
  name: 'UserAvatar',
  props: {
    url: {
      type: String,
      required: false,
      default: ''
    },
    size: {
      type: Number,
      required: false,
      default: 1
    }
  },
  data() {
    return {
      ava: null
    }
  },
  created() {
    // this.loadAvatar()
  },
  computed: {
    avatarUrl() {
      return toAppS3Url(this.url) || '/img/profile/avatar.png'
      // return this.ava || '/img/profile/avatar.png'
    },

    profileAvatarStyle() {
      const s1 = 192
      const s = s1 * this.size
      return {
        width: `${s}px`,
        height: `${s}px`,
        borderRadius: `calc(${s}px/2)`,
        backgroundImage: `url(${this.avatarUrl})`,
      }
    },
  },
  methods: {
    /*
    async loadAvatar() {
      if (!this.url)
        return
      const avatar = await supabase
        .storage
        .from('profiles')
        .download(this.url, 3600)
      // console.log('load@ava', this.url, avatar)
      if (avatar.data && !avatar.error)
        this.ava = URL.createObjectURL(avatar.data)
    }
    */
  },
  watch: {
    /*
    url(next, prev) {
      if (next === prev)
        return
      if (!next) {
        this.ava = null
      }
      this.loadAvatar()
    }
    */
  }
}
</script>

<template>
  <div class="profile-avatar" :style="profileAvatarStyle" />
</template>

<style lang="scss" scoped>
@import '@/assets/vyby.scss';

.profile-avatar {
  border: 1px solid darken($vyby-orange, 30%);
  background: #FFFFFF33;
  backdrop-filter: blur(4px);
  background-position: center center;
  background-size: cover;
}
</style>
